import { PlayerPreview } from './PlayerPreview'
import {Player} from '../assets/data'
import { Dispatch, SetStateAction } from 'react'
interface PlayersTableProps {
  players: Player[]
  setDetails: Dispatch<SetStateAction<null | Player>>
}

export const PlayersTable = ({ players, setDetails }: PlayersTableProps) => {
  return (
    // <div style={{ width: '50%' }}>
    <div>
      <div style={{ background: 'red', color: 'white', width: '100%' }}>
        <h2>{players.length} Rock Players</h2>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-around',
          width: '100%'
        }}
      >
        {players.map((player) => {
          return <PlayerPreview player={player} setDetails={setDetails} key={player.name} />
        })}
      </div>
    </div>
  )
}
